module.exports = __webpack_public_path__ + "static/img/3.ce912fa8.png";